//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    class_table: {
      type: String,
      default: "col"
    },
    customClasses: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      isOpen: false
    };
  },
  methods: {}
};